/**
 * Introduction
 * The RevSpring REST API provides a powerful and easy way to integrate RevSpring functionality into your own applications.You can browse through the supported operations in the Resources and Operations section below. You can even invoke the operations directly from this page using the corresponding \"Try this\" operation functionality!  Before using the RevSpring API, you will need to contact your RevSpring Account Representative. If you are new to RevSpring, please complete the following form to get the contract process started: [Contact Us Form](http://revspringinc.com/contact-us/) ## Getting started:   1. Obtain a unique set of credentials (a client_id, a client_secret) for use in your application by contacting  your RevSpring Account Manager. The client_id and the client_secret are required in order to generate an Access  Token. The RevSpring Account Manager will also be providing the clientId and clientType as these values are  required in all API calls other than the Auth operations.    2. All of the API calls require an Auth Access Token. Use the credentials provided in step 1 to generate an Auth  Access Token using the following method: /api/rest/auth/oauth/token.     3. Use the access_token returned to call any of the available REST API Operations. When calling other operations,  you will need to use the clientId and clientIdType in the Header along with the access_token.    4. The Try this operation button is available within each operation for testing.    ## Using the \"Try this\" operation functionality:  To use the \"Try this\" operation functionality applicable to each operation,  first provide valid values for each parameter under the \"Parameter\" column. To easily populate complex parameter values, select Model Schema under the \"Data Type\" column and then click on the JSON text that is revealed. You can then edit the populated \"Value\" field as needed, and click the corresponding \"Try this\" operation button to watch the API operation in action.    ## Try Postman :  Open the links and save to download the files. <a href = \"/apidoc/v1/api/postman/EM3_collection.json\"><strong>Postman Collection</strong></a>  <a href = \"/apidoc/v1/api/postman/EM3_environment.json\"><strong>Postman Variables</strong></a>  <br>   ## Error Codes :  Error codes which may appear when working with the API.  <a href = \"/apidoc/v1/api/errorcodes/codes.html\"><strong>Error Codes</strong></a>  <br> <br> © 2019 RevSpring. All Rights Reserved.  [Terms](http://revspringinc.com/terms-conditions/)   [Privacy](http://revspringinc.com/privacy-policy/) ## Resources and Operations
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AccessTokenError } from '../model/accessTokenError';
import { AccountTransactionResponse } from '../model/accountTransactionResponse';
import { AdminInfo } from '../model/adminInfo';
import { ConsumerCreateRequest } from '../model/consumerCreateRequest';
import { DatamartconsumerDataResponseMap } from '../model/datamartconsumerDataResponseMap';
import { ErrorMessage } from '../model/errorMessage';
import { InlineResponse200 } from '../model/inlineResponse200';
import { InlineResponse2001 } from '../model/inlineResponse2001';
import { InlineResponse2002 } from '../model/inlineResponse2002';
import { InlineResponse2003 } from '../model/inlineResponse2003';
import { InlineResponse2004 } from '../model/inlineResponse2004';
import { LineItemsRes } from '../model/lineItemsRes';
import { Request } from '../model/request';
import { Request1 } from '../model/request1';
import { Request2 } from '../model/request2';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class DataMgrService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * DataMgr_AdminInfo, Get the Admin Info
     * Gives the latest Version Control and Host Info
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dataMgrV1AdminInfoGet(observe?: 'body', reportProgress?: boolean): Observable<AdminInfo>;
    public dataMgrV1AdminInfoGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminInfo>>;
    public dataMgrV1AdminInfoGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminInfo>>;
    public dataMgrV1AdminInfoGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<AdminInfo>(`${this.basePath}/DataMgr/V1/Admin/Info`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * DataMgr_ConsumerAccountTransaction, Get Consumer Account Transaction records
     * Retrieve Consumer Account Transaction records based on given parameters
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param AccountNumber Enter the AccountNumber
     * @param StartDate Enter the StartDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dataMgrV1ConsumerAccountTransactionGet(OrgId: number, ConsumerNumber: string, AccountNumber?: string, StartDate?: string, observe?: 'body', reportProgress?: boolean): Observable<AccountTransactionResponse>;
    public dataMgrV1ConsumerAccountTransactionGet(OrgId: number, ConsumerNumber: string, AccountNumber?: string, StartDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AccountTransactionResponse>>;
    public dataMgrV1ConsumerAccountTransactionGet(OrgId: number, ConsumerNumber: string, AccountNumber?: string, StartDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AccountTransactionResponse>>;
    public dataMgrV1ConsumerAccountTransactionGet(OrgId: number, ConsumerNumber: string, AccountNumber?: string, StartDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling dataMgrV1ConsumerAccountTransactionGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling dataMgrV1ConsumerAccountTransactionGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (AccountNumber !== undefined) {
            queryParameters = queryParameters.set('AccountNumber', <any>AccountNumber);
        }
        if (StartDate !== undefined) {
            queryParameters = queryParameters.set('StartDate', <any>StartDate);
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<AccountTransactionResponse>(`${this.basePath}/DataMgr/V1/Consumer/Account/Transaction`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * DataMgr_ConsumerActivity, Get Consumer Activity records
     * Get Consumer Activity records based on given parameters
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Id Enter the Id
     * @param ActivityId Enter the ActivityId
     * @param StartDateTime Enter the Start date in yyyy-MM-ddTHH:mm:ss
     * @param EndDateTime Enter the End date in yyyy-MM-ddTHH:mm:ss
     * @param TimeZone Enter the timeZone (Supported TimeZones are EST, CST, PST, MST, UTC, AKST, HST)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dataMgrV1ConsumerActivityGet(OrgId: number, ConsumerNumber: string, Id?: number, ActivityId?: Array<number>, StartDateTime?: string, EndDateTime?: string, TimeZone?: string, observe?: 'body', reportProgress?: boolean): Observable<LineItemsRes>;
    public dataMgrV1ConsumerActivityGet(OrgId: number, ConsumerNumber: string, Id?: number, ActivityId?: Array<number>, StartDateTime?: string, EndDateTime?: string, TimeZone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LineItemsRes>>;
    public dataMgrV1ConsumerActivityGet(OrgId: number, ConsumerNumber: string, Id?: number, ActivityId?: Array<number>, StartDateTime?: string, EndDateTime?: string, TimeZone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LineItemsRes>>;
    public dataMgrV1ConsumerActivityGet(OrgId: number, ConsumerNumber: string, Id?: number, ActivityId?: Array<number>, StartDateTime?: string, EndDateTime?: string, TimeZone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling dataMgrV1ConsumerActivityGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling dataMgrV1ConsumerActivityGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (Id !== undefined) {
            queryParameters = queryParameters.set('Id', <any>Id);
        }
        if (ActivityId) {
            ActivityId.forEach((element) => {
                queryParameters = queryParameters.append('ActivityId', <any>element);
            })
        }
        if (StartDateTime !== undefined) {
            queryParameters = queryParameters.set('StartDateTime', <any>StartDateTime);
        }
        if (EndDateTime !== undefined) {
            queryParameters = queryParameters.set('EndDateTime', <any>EndDateTime);
        }
        if (TimeZone !== undefined) {
            queryParameters = queryParameters.set('TimeZone', <any>TimeZone);
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<LineItemsRes>(`${this.basePath}/DataMgr/V1/Consumer/Activity`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * DataMgr_ConsumerAuthenticate, Check if consumer id autheticated by checking the data
     * Get Consumer records based on given parameters
     * @param OrgId Enter the OrgId
     * @param Request Enter the ConsumerAuthenticate specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dataMgrV1ConsumerAuthenticatePost(OrgId: number, Request: Request, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse200>;
    public dataMgrV1ConsumerAuthenticatePost(OrgId: number, Request: Request, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse200>>;
    public dataMgrV1ConsumerAuthenticatePost(OrgId: number, Request: Request, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse200>>;
    public dataMgrV1ConsumerAuthenticatePost(OrgId: number, Request: Request, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling dataMgrV1ConsumerAuthenticatePost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling dataMgrV1ConsumerAuthenticatePost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<InlineResponse200>(`${this.basePath}/DataMgr/V1/Consumer/Authenticate`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * DataMgr_ConsumerData, Get ConsumerData
     * Retrieve ConsumerData records based on given parameters
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dataMgrV1ConsumerDataGet(OrgId: number, ConsumerNumber: string, observe?: 'body', reportProgress?: boolean): Observable<DatamartconsumerDataResponseMap>;
    public dataMgrV1ConsumerDataGet(OrgId: number, ConsumerNumber: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DatamartconsumerDataResponseMap>>;
    public dataMgrV1ConsumerDataGet(OrgId: number, ConsumerNumber: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DatamartconsumerDataResponseMap>>;
    public dataMgrV1ConsumerDataGet(OrgId: number, ConsumerNumber: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling dataMgrV1ConsumerDataGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling dataMgrV1ConsumerDataGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<DatamartconsumerDataResponseMap>(`${this.basePath}/DataMgr/V1/Consumer/Data`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * DataMgr_Consumer, Get Consumer records
     * Get Consumer records based on given parameters
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dataMgrV1ConsumerGet(OrgId: number, ConsumerNumber: string, observe?: 'body', reportProgress?: boolean): Observable<Array<InlineResponse2002>>;
    public dataMgrV1ConsumerGet(OrgId: number, ConsumerNumber: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<InlineResponse2002>>>;
    public dataMgrV1ConsumerGet(OrgId: number, ConsumerNumber: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<InlineResponse2002>>>;
    public dataMgrV1ConsumerGet(OrgId: number, ConsumerNumber: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling dataMgrV1ConsumerGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling dataMgrV1ConsumerGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<Array<InlineResponse2002>>(`${this.basePath}/DataMgr/V1/Consumer`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * DataMgr_ConsumerLineItem, Get LineItems records
     * Get LineItem records based on given parameters
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dataMgrV1ConsumerLineItemGet(OrgId: number, ConsumerNumber: string, observe?: 'body', reportProgress?: boolean): Observable<LineItemsRes>;
    public dataMgrV1ConsumerLineItemGet(OrgId: number, ConsumerNumber: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LineItemsRes>>;
    public dataMgrV1ConsumerLineItemGet(OrgId: number, ConsumerNumber: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LineItemsRes>>;
    public dataMgrV1ConsumerLineItemGet(OrgId: number, ConsumerNumber: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling dataMgrV1ConsumerLineItemGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling dataMgrV1ConsumerLineItemGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<LineItemsRes>(`${this.basePath}/DataMgr/V1/Consumer/LineItem`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_CreateConsumer, Create a Consumer
     * Consumer Create is used by ClientAdmin only
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param Request Enter the consumer details specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dataMgrV1ConsumerPost(OrgId: number, ConsumerNumber: string, Request: ConsumerCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<ConsumerCreateRequest>;
    public dataMgrV1ConsumerPost(OrgId: number, ConsumerNumber: string, Request: ConsumerCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ConsumerCreateRequest>>;
    public dataMgrV1ConsumerPost(OrgId: number, ConsumerNumber: string, Request: ConsumerCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ConsumerCreateRequest>>;
    public dataMgrV1ConsumerPost(OrgId: number, ConsumerNumber: string, Request: ConsumerCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling dataMgrV1ConsumerPost.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling dataMgrV1ConsumerPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling dataMgrV1ConsumerPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ConsumerCreateRequest>(`${this.basePath}/DataMgr/V1/Consumer`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * DataMgr_ConsumerRegistration, Search Consumer Registration records
     * Search Consumer Registration records based on given parameters
     * @param GroupId Enter the GroupId
     * @param request Enter the Consumer specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dataMgrV1ConsumerRegistrationPost(GroupId: number, request: Request1, observe?: 'body', reportProgress?: boolean): Observable<Array<InlineResponse2003>>;
    public dataMgrV1ConsumerRegistrationPost(GroupId: number, request: Request1, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<InlineResponse2003>>>;
    public dataMgrV1ConsumerRegistrationPost(GroupId: number, request: Request1, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<InlineResponse2003>>>;
    public dataMgrV1ConsumerRegistrationPost(GroupId: number, request: Request1, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling dataMgrV1ConsumerRegistrationPost.');
        }
        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling dataMgrV1ConsumerRegistrationPost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<Array<InlineResponse2003>>(`${this.basePath}/DataMgr/V1/Consumer/Registration`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * DataMgr_ConsumerSearch, Search Consumer records
     * Search Consumer records based on given parameters
     * @param GroupId Enter the GroupId
     * @param request Enter the Consumer specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dataMgrV1ConsumerSearchPost(GroupId: number, request: Request, observe?: 'body', reportProgress?: boolean): Observable<Array<InlineResponse2001>>;
    public dataMgrV1ConsumerSearchPost(GroupId: number, request: Request, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<InlineResponse2001>>>;
    public dataMgrV1ConsumerSearchPost(GroupId: number, request: Request, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<InlineResponse2001>>>;
    public dataMgrV1ConsumerSearchPost(GroupId: number, request: Request, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling dataMgrV1ConsumerSearchPost.');
        }
        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling dataMgrV1ConsumerSearchPost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<Array<InlineResponse2001>>(`${this.basePath}/DataMgr/V1/Consumer/Search`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * DataMgr_ConsumerStatementDownload, Download the consumer statement file
     * Download the consumer statement file based on ConsumerNumber and PdfId.
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param PdfId Enter the PdfId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dataMgrV1ConsumerStatementDownloadGet(OrgId: number, ConsumerNumber: string, PdfId: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public dataMgrV1ConsumerStatementDownloadGet(OrgId: number, ConsumerNumber: string, PdfId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public dataMgrV1ConsumerStatementDownloadGet(OrgId: number, ConsumerNumber: string, PdfId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public dataMgrV1ConsumerStatementDownloadGet(OrgId: number, ConsumerNumber: string, PdfId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling dataMgrV1ConsumerStatementDownloadGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling dataMgrV1ConsumerStatementDownloadGet.');
        }
        if (PdfId === null || PdfId === undefined) {
            throw new Error('Required parameter PdfId was null or undefined when calling dataMgrV1ConsumerStatementDownloadGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }
        if (PdfId !== undefined && PdfId !== null) {
            headers = headers.set('PdfId', String(PdfId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/pdf',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get(`${this.basePath}/DataMgr/V1/Consumer/Statement/Download`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * DataMgr_ConsumerStatementDownloadLink, Display the consumer statement file
     * Display and download the consumer statement file based on ConsumerNumber and PdfId.
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param PdfId Enter the PdfId
     * @param Authorization Enter the Authorization
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dataMgrV1ConsumerStatementDownloadLinkGet(OrgId: number, ConsumerNumber: string, PdfId: string, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public dataMgrV1ConsumerStatementDownloadLinkGet(OrgId: number, ConsumerNumber: string, PdfId: string, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public dataMgrV1ConsumerStatementDownloadLinkGet(OrgId: number, ConsumerNumber: string, PdfId: string, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public dataMgrV1ConsumerStatementDownloadLinkGet(OrgId: number, ConsumerNumber: string, PdfId: string, Authorization: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling dataMgrV1ConsumerStatementDownloadLinkGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling dataMgrV1ConsumerStatementDownloadLinkGet.');
        }
        if (PdfId === null || PdfId === undefined) {
            throw new Error('Required parameter PdfId was null or undefined when calling dataMgrV1ConsumerStatementDownloadLinkGet.');
        }
        if (Authorization === null || Authorization === undefined) {
            throw new Error('Required parameter Authorization was null or undefined when calling dataMgrV1ConsumerStatementDownloadLinkGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (OrgId !== undefined) {
            queryParameters = queryParameters.set('OrgId', <any>OrgId);
        }
        if (ConsumerNumber !== undefined) {
            queryParameters = queryParameters.set('ConsumerNumber', <any>ConsumerNumber);
        }
        if (PdfId !== undefined) {
            queryParameters = queryParameters.set('PdfId', <any>PdfId);
        }
        if (Authorization !== undefined) {
            queryParameters = queryParameters.set('Authorization', <any>Authorization);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/pdf',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get(`${this.basePath}/DataMgr/V1/Consumer/Statement/Download/Link`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * DataMgr_ConsumerStatement, Get Consumer Statement records
     * Get Consumer Statement records based on given parameters
     * @param OrgId Enter the OrgId
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param PdfId Enter the PdfId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dataMgrV1ConsumerStatementGet(OrgId: number, ConsumerNumber: string, PdfId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<InlineResponse2004>>;
    public dataMgrV1ConsumerStatementGet(OrgId: number, ConsumerNumber: string, PdfId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<InlineResponse2004>>>;
    public dataMgrV1ConsumerStatementGet(OrgId: number, ConsumerNumber: string, PdfId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<InlineResponse2004>>>;
    public dataMgrV1ConsumerStatementGet(OrgId: number, ConsumerNumber: string, PdfId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling dataMgrV1ConsumerStatementGet.');
        }
        if (ConsumerNumber === null || ConsumerNumber === undefined) {
            throw new Error('Required parameter ConsumerNumber was null or undefined when calling dataMgrV1ConsumerStatementGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (ConsumerNumber !== undefined && ConsumerNumber !== null) {
            headers = headers.set('ConsumerNumber', String(ConsumerNumber));
        }
        if (PdfId !== undefined && PdfId !== null) {
            headers = headers.set('PdfId', String(PdfId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<Array<InlineResponse2004>>(`${this.basePath}/DataMgr/V1/Consumer/Statement`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * DataMgr_GenericSearch, Search generically on ApiBroker api
     * Search generically on ApiBroker api based on given parameters
     * @param GroupId Enter the GroupId
     * @param request Enter the Consumer specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public dataMgrV1GenericSearchPost(GroupId: number, request: Request2, observe?: 'body', reportProgress?: boolean): Observable<Array<InlineResponse2003>>;
    public dataMgrV1GenericSearchPost(GroupId: number, request: Request2, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<InlineResponse2003>>>;
    public dataMgrV1GenericSearchPost(GroupId: number, request: Request2, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<InlineResponse2003>>>;
    public dataMgrV1GenericSearchPost(GroupId: number, request: Request2, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling dataMgrV1GenericSearchPost.');
        }
        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling dataMgrV1GenericSearchPost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<Array<InlineResponse2003>>(`${this.basePath}/DataMgr/V1/Generic/Search`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
